/*
 * currentSeasonId reducer
 */
import { SET_CURRENT_SEASON_ID } from './constants';

type State = string;

type Action = {
    +type: string,
    +payload: Object
};

const initialState = '';

export default function(state: State = initialState, action: Action) {
    switch (action.type) {
        case SET_CURRENT_SEASON_ID:
            return action.payload.seasonId;
        default:
            return state;
    }
}
